import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import PathInfo from "../../model/PathInfo";
import PathDisplay from "../common/PathDisplay";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import APIEndPoints from "../../utils/APIEndPoints";
import Site from "../../model/Site";

/*
  Component to manage the entire SITES section
*/
function Sites() {
  // read the ID from the url
  const { sid } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (sid) {
        const info = await apiClient?.get<Site>({
          url: APIEndPoints.SITES.ONE(parseInt(sid)),
        });

        setPathInfo(
          new PathInfo(info.id!, info.name, ChemiNovaEntityType.SITE, undefined)
        );
      } else {
        setPathInfo(undefined);
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default Sites;
